import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { MenuItem, Select } from '@mui/material';
import { parseISO } from 'date-fns';
import * as DATE from 'fp-ts/Date';
import { pipe } from 'fp-ts/function';
import * as Num from 'fp-ts/number';
import * as Ord from 'fp-ts/Ord';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
export var sortByAwardedOldest = pipe(DATE.Ord, Ord.contramap(function (badge) {
  return parseISO(badge.earnedDate);
}));
export var sortByAwardedLatest = Ord.reverse(sortByAwardedOldest);
export var sortByLevelLowest = pipe(Num.Ord, Ord.contramap(function (level) {
  var _level$0$level$rank, _level$, _level$$level;

  return (_level$0$level$rank = (_level$ = level[0]) === null || _level$ === void 0 ? void 0 : (_level$$level = _level$.level) === null || _level$$level === void 0 ? void 0 : _level$$level.rank) !== null && _level$0$level$rank !== void 0 ? _level$0$level$rank : 0;
}));
export var sortByLevelHighest = Ord.reverse(sortByLevelLowest);
export var filterList = {
  dateAwardedOldestFirst: {
    text: 'Date awarded: Oldest first'
  },
  dateAwardedLatestFirst: {
    text: 'Date awarded: Latest first'
  },
  levelLowestFirst: {
    text: 'Level: Lowest first'
  },
  levelHighestFirst: {
    text: 'Level: Highest first'
  }
};

var BadgeFilter = function BadgeFilter(_ref) {
  var handleBadgeFilter = _ref.handleBadgeFilter,
      badgeFilter = _ref.badgeFilter;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "BadgeFilter",
    "data-source-file": "badge-filter.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Select, {
        sx: {
          maxWidth: function maxWidth(t) {
            return t.spacing(32);
          }
        },
        size: "small",
        labelId: "badge-filter",
        onChange: handleBadgeFilter,
        label: t('Sort'),
        value: badgeFilter,
        children: Object.entries(filterList).map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              filterName = _ref3[0],
              filterOptions = _ref3[1];

          return /*#__PURE__*/_jsx(MenuItem, {
            value: filterName,
            children: t(filterOptions.text)
          }, filterName);
        })
      });
    }
  });
};

export default BadgeFilter;